import React from 'react';
import { ScanLabelConnectorApollo, withMobileAppMode } from '@front-activerse/common-components';
import { useLocation } from 'react-router-dom';
import TrackerScanLabelContainer from './TrackerScanLabelContainer';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';

const TrackerScanLabelPage: React.FC<{ mobileAppMode: boolean }> = ({ mobileAppMode }) => {
  const location = useLocation();
  const aiAccess = sessionStorage.getItem('aiAccess');

  if (aiAccess === 'true' || mobileAppMode) {
    return (
      <ScanLabelConnectorApollo>
        {({ scanLabel, cancelScanLabel }) => (
          <TrackerScanLabelContainer
            key={location.key}
            scanLabel={scanLabel}
            cancelScanLabel={cancelScanLabel}
          />
        )}
      </ScanLabelConnectorApollo>
    );
  }

  return <TrackerNoAccess />;
};

export default withMobileAppMode(TrackerScanLabelPage);
